import script from "./SelectPortfolio.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectPortfolio.vue?vue&type=script&setup=true&lang=js"

import "./SelectPortfolio.vue?vue&type=style&index=0&id=9f2294fa&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f2294fa"]])

export default __exports__